







import { Vue, Component, Prop } from 'vue-property-decorator';
import Observer from './observer';

@Component

export default class SlotVirtual extends Vue {
  @Prop({ default: 37 })
  elementHeight: any

  @Prop({ default: 40 })
  virtualizeCount: number

  isVisible: boolean = false;
  observer = Observer(this.loadAndUnobserve);

  timeoutId: any;

  get elHeight() {
    return this.elementHeight * this.virtualizeCount
  }

  get checkIsVisible() {
    return this.isVisible
  }


  loadAndUnobserve() {
    this.isVisible = true
    this.observer.unobserve(this.$el);
  };

  mounted() {
    this.observer.observe(this.$el);
  }

  destroyed() {
    this.observer.disconnect();
  }

}
